import React, { useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { SubmissionResultItem } from "../../containers/NewOrderContainer/types";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import getStyles from "./getStyles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import WarningIcon from "@material-ui/icons/Warning";

import "./OrderResultsModal.scss";
import { useHistory } from "react-router";
import { Box, Tab, Typography } from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import { Autocomplete } from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";

const OrderResultsModal = (props: any) => {
  const classes = getStyles();
  const [value, setValue] = React.useState(0);
  const [noAvailableAuthorisers, setNoAvailableAuthorisers] = React.useState<
    boolean
  >(false);
  const [selectedValue, setSelectedValue] = React.useState<any[]>([] as any[]);
  const history = useHistory();

  interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
  }

  function getValueById(id: number) {
    const value = selectedValue.find((x: any) => x.id === id);
    if (value) {
      return value.userDetails;
    } else {
      return null;
    }
  }

  useEffect(() => {
    props.items &&
      props.items.requiresAuthorisation &&
      props.items.requiresAuthorisation.forEach((item: any) => {
        if (item.availableAuthorisers.length === 0) {
          setNoAvailableAuthorisers(true);
        }
      });
  }, [props.items]);

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box p={3}>{children}</Box>}
      </Typography>
    );
  }

  function handleDoneButtonClick() {
    props.onClose();
    props.onReferredOrders(selectedValue);
    history.push("/orderHistory");
  }

  const ordersOrReturns = props.returns ? "returns" : "orders";

  return (
    <Dialog
      className="OrderResultsModal-dialog"
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth={"md"}
    >
      <DialogTitle className={classes.titleBar}>
        Authorisation Results
      </DialogTitle>
      <DialogContent>
        <div className="OrderResultsModal--contentContainer">
          <div className="OrderResultsModal--headerContainer">
            {props.items &&
            props.items.ordered &&
            props.items.ordered.length > 0 &&
            props.items &&
            props.items.requiresAuthorisation &&
            props.items.requiresAuthorisation.length === 0 ? (
              <>
                <CheckCircleIcon className="OrderResultsModal--authorisedIcon" />
                <div className="OrderResultsModal--headerText">
                  Your {ordersOrReturns} have been authorised. Please review the
                  results.
                </div>
              </>
            ) : props.items &&
              props.items.ordered &&
              props.items.ordered.length === 0 &&
              props.items.requiresAuthorisation &&
              props.items.requiresAuthorisation.length > 0 ? (
              <>
                <WarningIcon className="OrderResultsModal--requiresAuthorisingIcon" />
                <div className="OrderResultsModal--headerTextContainer">
                  <div className="OrderResultsModal--headerText OrderResultsModal--couldNotBeAuthorisedText">
                    Your orders could not be authorised. Please review the
                    results.
                  </div>
                  {noAvailableAuthorisers ? (
                    <div className="OrderResultsModal--headerText OrderResultsModal--warningText">
                      Some {ordersOrReturns} can not be referred. Please see the
                      highlighted {ordersOrReturns} below and contact CFXD
                      support to get highlighted {ordersOrReturns} below and
                      contact CFXD support to get this authorised
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </>
            ) : props.items &&
              props.items.ordered &&
              props.items.ordered.length > 0 &&
              props.items.requiresAuthorisation &&
              props.items.requiresAuthorisation.length > 0 ? (
              <>
                <WarningIcon className="OrderResultsModal--requiresAuthorisingIcon" />
                <div className="OrderResultsModal--headerTextContainer">
                  <div className="OrderResultsModal--headerText">
                    Some {ordersOrReturns} require authorising. Please review
                    the results.
                  </div>
                  {noAvailableAuthorisers ? (
                    <div className="OrderResultsModal--headerText OrderResultsModal--warningText">
                      Some {ordersOrReturns} can not be referred. Please see the
                      highlighted {ordersOrReturns} below and contact CFXD
                      support to get this authorised.
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </>
            ) : (
              <></>
            )}
          </div>

          <div className={classes.root}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab
                className={`${classes.tabLabel} OrderResultsModal--orderedTab`}
                label={`Submitted (${props.items &&
                  props.items.ordered &&
                  props.items.ordered.length})`}
              />
              <Tab
                className={`${classes.tabLabel} OrderResultsModal--requiresAuthorisationTab`}
                label={`Requires Authorisation (${props.items &&
                  props.items.requiresAuthorisation &&
                  props.items.requiresAuthorisation.length})`}
              />
              <Tab
                className={`${classes.tabLabel} OrderResultsModal--failedTab`}
                label={`Failed (${props.items &&
                  props.items.failed &&
                  props.items.failed.length})`}
              />
            </Tabs>
            <TabPanel value={value} index={0}>
              <table className="OrderResultsTable-container">
                <thead className="OrderResultsTable--headPanel">
                  <tr className="OrderResultsTable--headPanelRow">
                    <th>Branch</th>
                    <th>Currency</th>
                    <th>Currency Amount</th>
                    <th>GBP Amount</th>
                    <th>Traveller/Beneficiary</th>
                    <th>Date Placed</th>
                    <th>Date Required</th>
                  </tr>
                </thead>
                <tbody>
                  {props.items &&
                    props.items.ordered &&
                    props.items.ordered.map((item: SubmissionResultItem) => (
                      <tr className="OrderResultsTable--row">
                        <td className="OrderResultsTable-branch">
                          {item.branchName}
                        </td>
                        <td className="OrderResultsTable-currency">
                          {item.currencyRegion} - {item.currencyName}
                        </td>
                        <td className="OrderResultsTable-currencyAmount">
                          {item.currencyAmount
                            .toLocaleString(navigator.language, {
                              minimumFractionDigits: 2
                            })
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </td>
                        <td className="OrderResultsTable-gbpAmount">
                          {item.baseCurrencyAmount
                            .toLocaleString(navigator.language, {
                              minimumFractionDigits: 2
                            })
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </td>
                        <td className="OrderResultsTable-travellerBeneficiary">
                          {item.travellerBeneficiary}
                        </td>
                        <td className="OrderResultsTable-orderedAt">
                          {item.orderedAt}
                        </td>
                        <td className="OrderResultsTable-requiredAt">
                          {item.requiredAt}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <table className="OrderResultsTable-container">
                <thead className="OrderResultsTable--headPanel">
                  <tr className="OrderResultsTable--headPanelRow">
                    <th>Branch</th>
                    <th>Currency</th>
                    <th>Currency Amount</th>
                    <th>GBP Amount</th>
                    <th>Traveller/Beneficiary</th>
                    <th>Date Placed</th>
                    <th>Date Required</th>
                    <th>Reason</th>
                    <th>Refer To</th>
                  </tr>
                </thead>
                <tbody>
                  {props.items &&
                    props.items.requiresAuthorisation &&
                    props.items.requiresAuthorisation.map(
                      (item: SubmissionResultItem) => (
                        <tr
                          className={`${
                            item.availableAuthorisers &&
                            item.availableAuthorisers.length === 0
                              ? classes.highlightedRow
                              : classes.unHighlightedRow
                          } OrderResultsTable--row`}
                        >
                          <td className="OrderResultsTable-branch">
                            {item.branchName}
                          </td>
                          <td className="OrderResultsTable-currency">
                            {item.currencyRegion} - {item.currencyName}
                          </td>
                          <td className="OrderResultsTable-currencyAmount">
                            {item.currencyAmount
                              .toLocaleString(navigator.language, {
                                minimumFractionDigits: 2
                              })
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </td>
                          <td className="OrderResultsTable-gbpAmount">
                            {item.baseCurrencyAmount
                              .toLocaleString(navigator.language, {
                                minimumFractionDigits: 2
                              })
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          </td>
                          <td className="OrderResultsTable-travellerBeneficiary">
                            {item.travellerBeneficiary}
                          </td>
                          <td className="OrderResultsTable-orderedAt">
                            {item.orderedAt}
                          </td>
                          <td className="OrderResultsTable-requiredAt">
                            {item.requiredAt}
                          </td>
                          <td className="OrderResultsTable-reason">
                            {item.orderAuthorisationReason}
                          </td>
                          <td className="OrderResultsTable-referTo">
                            <div className="OrderResultsTable-referToContainer">
                              {item.availableAuthorisers &&
                              item.availableAuthorisers.length > 0 ? (
                                <Autocomplete
                                  id="combo-box-demo"
                                  value={getValueById(item.id)}
                                  onChange={(event: any, newValue: any) => {
                                    if (newValue === null) {
                                      setSelectedValue(
                                        selectedValue.filter(
                                          (val: any) => val.id !== item.id
                                        )
                                      );
                                    } else {
                                      let foundIndex = selectedValue.findIndex(
                                        (val: any) => val.id === item.id
                                      );
                                      if (foundIndex > -1) {
                                        setSelectedValue(
                                          (selectedValue[
                                            foundIndex
                                          ].userDetails = newValue)
                                        );
                                      } else {
                                        setSelectedValue(selectedValue => [
                                          ...selectedValue,
                                          {
                                            id: item.id,
                                            version: item.version,
                                            userDetails: newValue
                                          }
                                        ]);
                                      }
                                    }
                                  }}
                                  options={item.availableAuthorisers}
                                  getOptionLabel={(option: any) =>
                                    `${option.firstName} ${option.lastName}`
                                  }
                                  style={{ width: 200 }}
                                  renderInput={(params: any) => (
                                    <TextField
                                      {...params}
                                      placeholder={"Not Referred"}
                                      className={`${classes.inputField} OrderResultsTable-referToText`}
                                      variant="outlined"
                                    />
                                  )}
                                />
                              ) : (
                                <></>
                              )}
                            </div>
                          </td>
                        </tr>
                      )
                    )}
                </tbody>
              </table>
            </TabPanel>
            <TabPanel value={value} index={2}>
              <table className="OrderResultsTable-container">
                <thead className="OrderResultsTable--headPanel">
                  <tr className="OrderResultsTable--headPanelRow">
                    <th>Branch</th>
                    <th>Currency</th>
                    <th>Currency Amount</th>
                    <th>GBP Amount</th>
                    <th>Traveller/Beneficiary</th>
                    <th>Date Placed</th>
                    <th>Date Required</th>
                    <th>Reason</th>
                  </tr>
                </thead>
                <tbody>
                  {props.items &&
                    props.items.failed &&
                    props.items.failed.map((item: SubmissionResultItem) => (
                      <tr className="OrderResultsTable--row">
                        <td className="OrderResultsTable-branch">
                          {item.branchName}
                        </td>
                        <td className="OrderResultsTable-currency">
                          {item.currencyRegion} - {item.currencyName}
                        </td>
                        <td className="OrderResultsTable-currencyAmount">
                          {item.currencyAmount
                            .toLocaleString(navigator.language, {
                              minimumFractionDigits: 2
                            })
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </td>
                        <td className="OrderResultsTable-gbpAmount">
                          {item.baseCurrencyAmount
                            .toLocaleString(navigator.language, {
                              minimumFractionDigits: 2
                            })
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </td>
                        <td className="OrderResultsTable-travellerBeneficiary">
                          {item.travellerBeneficiary}
                        </td>
                        <td className="OrderResultsTable-orderedAt">
                          {item.orderedAt}
                        </td>
                        <td className="OrderResultsTable-requiredAt">
                          {item.requiredAt}
                        </td>
                        <td className="OrderResultsTable-reason">
                          {item.failedReason}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </TabPanel>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          id="the-close-button"
          onClick={handleDoneButtonClick}
          color="primary"
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OrderResultsModal;
